// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Icon from '../_common/form/Icon';
import Title from '../_common/form/Title';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${({ collapsed }) => collapsed ? '0.4em 1em' : '1em'};
    // margin: 1em ${({ os }) => os !== 'iOS' ? '0' : '14px'} 1em 14px;
    margin: 1em 14px;
    border-radius: 1rem;
    color: ${({ theme }) => theme.mobile.text};
    background: ${({ theme }) => theme.mobile.background};
    box-shadow: 1px 1px 5px 1px ${({ theme }) => theme.mobile.shadow};
    transition: all 0.2s;

    ${({ height, collapsed }) => collapsed ? `height: 2em;` : height && `height: ${height}px;`};

    ${({ noSlide }) => !noSlide ? 'animation:  slideInFromRight 0.3s;' : ''};
`
const Overflow = styled.div`
    overflow: hidden;
`
const HeightWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
    height: 2em;
    //height: ${({ collapsed }) => collapsed ? `2em` : `3em`};
`
const I = styled(Icon)`
    transform: rotate(${({ collapsed }) => collapsed ? '90deg' : '0deg'});
    transition: all 0.3s;
`

const Card = ({ smooth, children, ...props }) => {
    const {
        state: {
            OS
        },
    } = useGlobalState();

    const [cardHeight, setCardHeight] = useState(null)
    const [collapsed, setCollapsed] = useState(props.collapsible)
    const cardRef = useRef(null);

    const observer = useRef(
        new ResizeObserver(entries => {
            const { height } = entries[0].contentRect
            setCardHeight(height)
            //setCardHeight(cardRef.current?.getBoundingClientRect().height)
        })
    )

    useEffect(() => {
        const element = observer.current;
        const ref = cardRef.current;

        if (element) {
            element.observe(ref)
        }

        return () => element.unobserve(ref)
    }, [cardRef, observer])

    // useEffect(() => {
    //     if (!smooth) return;
    //     setCardHeight(cardRef.current?.getBoundingClientRect().height)
    // }, [smooth])

    const handleClick = (e, body) => {
        if (!props.collapsible) return;
        setCollapsed(!collapsed);
    }

    return (
        <Wrapper height={cardHeight} collapsed={collapsed} noSlide={props.noSlide} className={props.className} os={OS}>
            <Overflow>
                <HeightWrapper ref={cardRef}  {...props}>
                    {
                        props.collapsible ?
                            <Row collapsed={collapsed} onClick={handleClick}>
                                <Title icon={props.icon}>{props.title}</Title>
                                <I icon='chevronDown' collapsed={collapsed ? 1 : 0} />
                            </Row> :
                            props.title ?
                                <Title icon={props.icon}>{props.title}</Title> : null
                    }
                    {children}
                </HeightWrapper>
            </Overflow>
        </Wrapper>
    );
}

export default Card;